// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n/* .merged-msg-container {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 380px;\n  text-align: center;\n  z-index: 1;\n  color: #ff5722;\n  font-size: 11px;\n  font-weight: bold;\n  background-color: #fff9e6;\n  padding: 4px 12px;\n  border-radius: 4px;\n} */\n/* :deep(.q-table td) {\n  position: relative;\n  overflow: visible;\n} */\n", ""]);
// Exports
module.exports = exports;
